import type { OrderOffer } from '@fourthwall/services/dist/models/order'

import { addExistingItemQuantity } from './addExistingItemQuantity'

export const aggregateOffers = (offers?: OrderOffer[]): OrderOffer[] => {
  if (!offers) {
    return []
  }

  return offers.reduce((accumulator: OrderOffer[], offer) => {
    const existingOffer = accumulator.find((orderOffer) => orderOffer.variantId === offer.variantId)
    if (existingOffer) {
      return addExistingItemQuantity(accumulator, existingOffer)
    }

    return [...accumulator, offer]
  }, [])
}
